module.exports = __webpack_public_path__ + "img/ssbg1.3e4420cb.jpg";